import { ReactNode } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

export interface IncomeExpenseWrapperProps {
  children: ReactNode;
  remove: () => void;
}

const IncomeExpenseWrapper: React.FunctionComponent<IncomeExpenseWrapperProps> =
  function ({ children, remove }) {
    return (
      <div className="relative mb-6 md:mb-0 md:pr-10">
        <Button.Icon
          id="finance-details-remove"
          onClick={remove}
          icon="remove"
          variant="ghost-grey"
          size="28-16"
          className="-mt-1.5 absolute right-0 md:top-8 -bottom-4 md:bottom-0"
          iconProps={{ stroke: 'red-200' }}
        />
        {children}
      </div>
    );
  };

export default IncomeExpenseWrapper;
